module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-five-sub-one.a1e2eff3.jpg";